module.exports = __webpack_public_path__ + "static/img/experience-pic1.4e67fab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/experience-pic1.png
// module id = 1sDQ
// module chunks = 0